import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/ReportSubscriptions'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class ReportSubscriptionsStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "ReportSubscriptionsStore",
			variables: false,
		})
	}
}

export async function load_ReportSubscriptions(params) {
  await initClient()

	const store = new ReportSubscriptionsStore()

	await store.fetch(params)

	return {
		ReportSubscriptions: store,
	}
}
